@if (!hideNavigation) {
  <div class="navigation-wrapper">
    <div class="mobile-nav">
      <div class="nav-item">
        <a
          [routerLink]="['/']"
          routerLinkActive="active"
          [routerLinkActiveOptions]="{ paths: 'exact', queryParams: 'ignored' }"
          >
          <div class="bg-container">
            <img
              class="icons unselected"
              src="/images/icons/navigation-home.svg"
              alt=""
              />
              <img
                class="icons icon-selected"
                src="/images/icons/navigation-home-blue.svg"
                alt=""
                />
                <p>
                  <!-- @defer(){ -->
                    <!-- {{ 'nav.home' | translate }} -->
                  <!-- } -->
                  <!-- @placeholder { -->
                    Shop
                  <!-- } -->
                </p>
              </div>
            </a>
          </div>
          <div class="nav-item">
            <a
              [routerLink]="['/category', 'list']"
              routerLinkActive="active"
              >
              <div class="bg-container">
                <img
                  class="icons unselected"
                  src="/images/icons/navigation-category.svg"
                  alt=""
                  />
                  <img
                    class="icons icon-selected"
                    src="/images/icons/navigation-category-blue.svg"
                    alt=""
                    />
                    <p>
                      <!-- @defer(){
                        {{ 'nav.categories' | translate }}
                      }
                      @placeholder { -->
                        Categories
                      <!-- } -->
                    </p>
                  </div>
                </a>
              </div>
              <div class="nav-item">
                <!-- <a
                [routerLink]="['/profile', 'order-history']"
                routerLinkActive="active"
                [routerLinkActiveOptions]="{ exact: true }"
                >
                <div class="bg-container">
                  <img
                    class="icons unselected"
                    src="/images/icons/navigation-notepad.svg"
                    alt=""
                    />
                    <img
                      class="icons icon-selected"
                      src="/images/icons/navigation-notepad-blue.svg"
                      alt=""
                      />
                      <p>{{ 'nav.orders' | translate }}</p>
                    </div>
                  </a> -->
                  <button
                    mat-button
                    (click)="goToOrderHistory()"
                    [ngClass]="{ active: router.url.includes('/profile/order-history') }"
                    >
                    <div class="bg-container">
                      <img
                        class="icons unselected"
                        src="/images/icons/navigation-notepad.svg"
                        alt=""
                        />
                        <img
                          class="icons icon-selected"
                          src="/images/icons/navigation-notepad-blue.svg"
                          alt=""
                          />
                          <p>
                            <!-- @defer(){
                              {{ 'nav.orders' | translate }}
                            }
                            @placeholder { -->
                              Orders
                            <!-- } -->
                          </p>
                        </div>
                      </button>
                    </div>
                    <div class="nav-item">
                      <a
        routerLink="{{
          isClubMember ? '/kingclub/club-levels' : '/landing/kingclub'
        }}"
                        routerLinkActive="active"
                        [routerLinkActiveOptions]="{ exact: true }"
                        >
                        <div class="bg-container">
                          <img
                            class="icons unselected"
                            src="https://d1upatzsvnpphr.cloudfront.net/broker/notification_system/media/file/crown-grey.svg"
                            alt=""
                            />
                            <img
                              class="icons icon-selected"
                              src="https://d1upatzsvnpphr.cloudfront.net/broker/notification_system/media/file/crown-blue.svg"
                              alt=""
                              />
                              <p>
                                <!-- @defer(){
                                  {{ 'nav.kingClub' | translate }}
                                }
                                @placeholder { -->
                                  KingClub
                                <!-- } -->
                              </p>
                            </div>
                          </a>
                        </div>
                        <div class="nav-item">
                          <a
                            [routerLink]="['/profile']"
                            routerLinkActive="active"
                            [routerLinkActiveOptions]="{ exact: true }"
                            >
                            <div class="bg-container">
                              <img
                                class="icons unselected"
                                src="/images/icons/navigation-user.svg"
                                alt=""
                                />
                                <img
                                  class="icons icon-selected"
                                  src="/images/icons/navigation-user-blue.svg"
                                  alt=""
                                  />
                                  <p>
                                    <!-- @defer(){
                                      {{ 'nav.profile' | translate }}
                                    }
                                    @placeholder { -->
                                      Profile
                                    <!-- } -->
                                  </p>
                                </div>
                              </a>
                            </div>
                          </div>
                        </div>
                      }
